import { forwardRef, startTransition } from 'react';

import { Table } from './Table';
import { VirtuosoTableRowProps } from './VirtuosoTableContext';

export const VirtuosoTableRow = forwardRef<
  HTMLTableRowElement,
  VirtuosoTableRowProps<any>
>(function VirtuosoTableRow({ context, children, ...props }, ref) {
  const { activeRowIds, onRowSelect, table, tableRows } = context || {};
  const row = props.item;
  const index = (props as any)['data-item-index'];

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    startTransition(() =>
      onRowSelect?.(tableRows ?? table?.getRowModel().rows, row, index)
    );
  };

  return (
    <Table.Row
      ref={ref}
      {...props}
      onClick={handleClick}
      selected={Boolean(activeRowIds?.has(row.id))}
      selectable={Boolean(onRowSelect || table?.options.enableRowSelection)}
    >
      {children}
    </Table.Row>
  );
});
